/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 *
 *
 * @author Evgenij Tyan
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.0.1
 */

import { makeStyles } from '@material-ui/core/styles';

/**
 * Function generates an arrow near tooltip.
 * This is the modified example from docs - https://material-ui.com/components/tooltips/#tooltips
 * @param color - css color string.
 */
const arrowGenerator = (color: string) => {
    return {
        '&[x-placement*="bottom"] $arrow': {
            'top': 0,
            'left': 'calc(50% - 1.5em)',
            'marginTop': '-0.95em',
            'width': '3em',
            'height': '1em',
            '&::before': {
                borderWidth: '0 1em 1em 1em',
                borderColor: `transparent transparent ${color} transparent`,
            },
        },
        '&[x-placement*="bottom-start"] $arrow': {
            left: 0,
        },
        '&[x-placement*="bottom-end"] $arrow': {
            left: 'auto',
            right: 0,
        },
        '&[x-placement*="top"] $arrow': {
            'bottom': 0,
            'left': 'calc(50% - 1.5em)',
            'marginBottom': '-0.95em',
            'width': '3em',
            'height': '1em',
            '&::before': {
                borderWidth: '1em 1em 0 1em',
                borderColor: `${color} transparent transparent transparent`,
            },
        },
        '&[x-placement*="top-start"] $arrow': {
            left: 0,
        },
        '&[x-placement*="top-end"] $arrow': {
            left: 'auto',
            right: 0,
        },
        '&[x-placement*="right"] $arrow': {
            'left': 0,
            'marginLeft': '-0.95em',
            'height': '3em',
            'width': '1em',
            '&::before': {
                borderWidth: '1em 1em 1em 0',
                borderColor: `transparent ${color} transparent transparent`,
            },
        },
        '&[x-placement*="right-start"] $arrow': {
            top: 0,
        },
        '&[x-placement*="right-end"] $arrow': {
            top: 'auto',
            bottom: 0,
        },
        '&[x-placement*="left"] $arrow': {
            'right': 0,
            'marginRight': '-0.95em',
            'height': '3em',
            'width': '1em',
            '&::before': {
                borderWidth: '1em 0 1em 1em',
                borderColor: `transparent transparent transparent ${color}`,
            },
        },
        '&[x-placement*="left-start"] $arrow': {
            top: 0,
        },
        '&[x-placement*="left-end"] $arrow': {
            top: 'auto',
            bottom: 0,
        },
    };
};

/**
 * Styles for popup and arrow.
 * This is the modified example from docs - https://material-ui.com/components/tooltips/#tooltips
 */
const useStylesArrow = () => makeStyles(() => ({
    arrow: {
        'position': 'absolute',
        'fontSize': 6,
        'width': '3em',
        'height': '3em',
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: 0,
            height: 0,
            borderStyle: 'solid',
        },
    },
    tooltip: {
        position: 'relative',
        maxWidth: '100%',
        padding: '28px',
        boxSizing: 'border-box',
        backgroundColor: 'white',
        boxShadow: '0 0px 12px 0 rgba(51, 51, 51, 0.2)',
        borderRadius: 0,
    },
    popper: arrowGenerator('white'),
}));

export {
    useStylesArrow,
};
